export const ReportHeaderStyle = {
    backgroundColor: 'var(--pm-accent)',
    color: 'black',
    fontFamily: 'Verdana, Geneva, sans-serif',
    fontWeight: 500,
    fontSize: '15px',
    textShadow: '1px 1px 2px rgba(0, 0, 0, 0.11)',
};

export const ReportCellStyle = {
    color: 'black',
    fontFamily: 'Verdana, Geneva, sans-serif',
    fontWeight: 400,
    fontSize: '15px',
};
